module.exports = __webpack_public_path__ + "img/zoom-addin-02.77614ec8.png";